<template>
    <div class="header-search-form">
        <div class="input-group">
            <input type="search" class="form-control header-search-input" placeholder="Suchbegriff..." ref="searchInput" v-model="searchString"
                @input="onValueChanged($event.target.value)" @keyup.enter="search()" @focus="isSearchFocused = true"
                @blur="onBlurSearchField($event)" :autofocus="isShopBuilder">

            <div class="input-group-append">
                <slot name="search-button">
                    <button class="btn header-search-btn" type="submit" @click="search()">
                        <i class="fa fa-search"></i>
                    </button>
                </slot>
            </div>
        </div>

        <div v-if="ismobile" class="search-mobile__results-wrapper">
            <div class="search-mobile__results" v-show="hasAutocompleteResults">
                <slot name="autocomplete-suggestions">
                    <div class="autocomplete-suggestions bg-white w-100 ">
                        <search-suggestion-item :show-images="true" suggestion-type="item">
                        </search-suggestion-item>
                    </div>
                </slot>

                <div class="search-mobile__btn-wrapper">
                    <button class="search-mobile__show-all-btn" @click="search()" v-if="ismobile">{{ $translate("Ceres::Template.homepageShowAll") }}</button>
                </div>
            </div>

            <div class="search-mobile-error" v-if="!hasAutocompleteResults && (searchString.length >=2) && isLoading===false">{{ $translate("TuningFanatics::Template.mobileSearchError") }}</div>
        </div>

        <div class="search__results-wrapper" v-if="isSearchFocused && !ismobile && (searchString.length >=2)">
            <span class="search__close" @click="closeSearch()"></span>
            <div class="search__headline" v-if="(searchString.length >=2) && isLoading===false">{{ $translate("TuningFanatics::Template.searchHeadline") }}</div>
            <div v-show="hasAutocompleteResults">
                <slot name="autocomplete-suggestions">
                    <div class="autocomplete-suggestions bg-white w-100 ">
                        <search-suggestion-item :show-images="true" suggestion-type="item">
                        </search-suggestion-item>
                    </div>
                </slot>
            </div>

            <div class="search__error" v-if="!hasAutocompleteResults && (searchString.length >=2) && isLoading===false" v-html="$translate('TuningFanatics::Template.searchError')"></div>
        </div>
    </div>
</template>

<script>
    import UrlService from "ceres/app/services/UrlService";
    import {
        isNullOrUndefined,
        defaultValue
    } from "ceres/app/helper/utils";
    import {
        pathnameEquals
    } from "ceres/app/helper/url";
    import ApiService from "ceres/app/services/ApiService";
    import {
        mapState
    } from 'vuex';
    import {
        debounce
    } from 'ceres/app/helper/debounce';

    export default {

        name: "item-search",

        props: {
            ismobile: Boolean,

            showItemImages: {
                type: Boolean
            },
            forwardToSingleItem: {
                type: Boolean,
                default: App.config.search.forwardToSingleItem
            },
            timeout: {
                type: Number,
                default: 500
            }
        },

        data() {
            return {
                isSearchFocused: App.isShopBuilder,
                onValueChanged: null,
                searchString: "",
                isLoading: false,
            };
        },

        created() {
            this.onValueChanged = debounce(searchString => {
                this.autocomplete(searchString);
            }, defaultValue(this.timeout, 500));
        },

        computed: {
            hasAutocompleteResults() {
                const item = this.autocompleteResult.item;
                const category = this.autocompleteResult.category;
                const suggestion = this.autocompleteResult.suggestion;

                return App.isShopBuilder || (item && item.length) || (category && category.length) || (suggestion &&
                    suggestion.length);
            },

            isShopBuilder() {
                return App.isShopBuilder;
            },

            ...mapState({
                autocompleteResult: state => state.itemSearch.autocompleteResult,
                moduleSearchString: state => state.itemList.searchString
            })
        },

        mounted() {
            this.$nextTick(() => {
                const urlParams = UrlService.getUrlParams(document.location.search);

                this.$store.commit("setItemListSearchString", urlParams.query);

                this.$refs.searchInput.value = !isNullOrUndefined(urlParams.query) ? urlParams.query : "";
            });
        },

        methods: {
            closeSearch(){
                this.isSearchFocused = false;
            },

            search() {
                if (this.$refs.searchInput.value.length) {
                    if (pathnameEquals(App.urls.search)) {
                        this.$store.dispatch("searchItems", this.$refs.searchInput.value);
                    } else {
                        window.open(`${App.urls.search}?query=${ this.searchString }`, "_self", false);
                    }
                }
            },
            autocomplete(searchString) {
                if (searchString.length >= 2) {
                    this.isLoading = true;

                    this.$store.dispatch("loadItemSearchAutocomplete", searchString).finally(()=>{
                        this.isLoading = false
                    });
                } else {
                    this.$store.commit("setAutocompleteResult", {
                        item: [],
                        category: [],
                        suggestion: []
                    });
                }
            },

            // hide search, if targetElement of the blur event is not a child of components' root element
            onBlurSearchField(event) {
                const target = event.relatedTarget;

                if (isNullOrUndefined(target) || !isNullOrUndefined(target) && !this.$el.contains(target)) {
                    this.isSearchFocused = false;
                }
            }
        },

        watch: {
            // set the current search string, after clicking on a suggestion
            moduleSearchString(newVal) {
                if (newVal && newVal.length) {
                    this.searchString = newVal;
                }
            }
        }
    }
</script>
